import { redirect } from "@tanstack/react-router";
import type { AuthInfo } from "../hooks/useAuth";
import type { UserRole } from "../types";

export const requireAuth = (authInfo: AuthInfo) => {
  if (!authInfo.isAuthenticated) {
    const params = new URLSearchParams(window.location.search);
    const activate = params.get("activate");
    const email = params.get("email");

    throw authInfo.loginWithRedirect({
      appState: { returnTo: window.location.pathname + window.location.search },
      authorizationParams: {
        ...(activate && { activate }),
        ...(email && { login_hint: email }),
      },
    });
  }
};

export const requireUserRole = (authInfo: AuthInfo, allowedUserRoles: UserRole[]) => {
  requireAuth(authInfo);

  const hasAccess = authInfo.userRole && allowedUserRoles.includes(authInfo.userRole);
  if (!hasAccess) {
    throw redirect({ to: "/unauthorized" });
  }
};
